export default "__VITE_PUBLIC_ASSET__94bab4b8__"